gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);

let smoother;
let mm = gsap.matchMedia();

function setupWpdHoverPauseForSmoother() {
	const selector = '#wpdNetMainContainer, .wpdNetMainContainer';

	const attach = (el) => {
		if (!el || el.__wpdHoverPauseAttached) return;
		el.__wpdHoverPauseAttached = true;

		let unpauseOnLeave = false;

		el.addEventListener('mouseenter', () => {
			if (!smoother || typeof smoother.paused !== 'function') return;

			// Don't unpause on leave if something else already paused it.
			const alreadyPaused = Boolean(smoother.paused());
			if (!alreadyPaused) {
				smoother.paused(true);
				unpauseOnLeave = true;
			} else {
				unpauseOnLeave = false;
			}
		});

		el.addEventListener('mouseleave', () => {
			if (!smoother || typeof smoother.paused !== 'function') return;
			if (unpauseOnLeave) smoother.paused(false);
			unpauseOnLeave = false;
		});
	};

	document.querySelectorAll(selector).forEach(attach);

	// WPD container can be injected after load, so observe for it.
	const observer = new MutationObserver(() => {
		document.querySelectorAll(selector).forEach(attach);
	});
	observer.observe(document.body, { childList: true, subtree: true });
}

// gsap matchmedia
mm.add('(min-width: 1024px)', () => {
	smoother = ScrollSmoother.create({
		smooth: 1, //Delay in seconds
		effects: true,
		smoothTouch: false, //Mobile delay disabled.
		normalizeScroll: true,
	});
});

mm.add('(max-width: 1023px)', () => {
	smoother = ScrollSmoother.create({
		smooth: 0.7, //Delay in seconds
		effects: true,
		smoothTouch: false, //Mobile delay disabled.
	});
});

// Throttled ScrollTrigger refresh on resize
let resizeTimeout;
const resizeObserver = new ResizeObserver(() => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(() => {
		ScrollTrigger.refresh();
	}, 100);
});
resizeObserver.observe(document.body);

// // Init Lenis
// let lenis = new Lenis({
//     duration: 1.2,
//     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
//     direction: 'vertical',
//     gestureDirection: 'vertical',
//     smooth: true,
//     mouseMultiplier: 1,
//     smoothTouch: false,
//     touchMultiplier: 2,
//     infinite: false,
//     overscroll: true,
// });

// // Sync Lenis with GSAP
// gsap.ticker.lagSmoothing(0);

// lenis.on('scroll', ScrollTrigger.update);

// gsap.ticker.add((time) => {
//     lenis.raf(time * 1000);
// });

//Removed sticky header because of multiple sticky panel sections.
//To re-enable move header outside of smooth scroll container.

//Sticky header reveal/hide
const offset = 100;
const blurThreshold = 100; // Blur threshold in pixels
let lastScrollTop = 0;

smoother.scrollTrigger.scroller.addEventListener('scroll', () => {
	const currentScrollTop = smoother.scrollTrigger.scroll();
	const scrollDifference = currentScrollTop - lastScrollTop;

	if (Math.abs(scrollDifference) > offset) {
		const yOffset = scrollDifference > 0 ? '-101%' : '0%';

		gsap.to('.shopify-section-group-header-group', {
			y: yOffset,
			ease: 'power2.out',
		});

		lastScrollTop = currentScrollTop;
	}

	// // Add or remove 'scrolled' class based on scroll position
	// if (currentScrollTop > 100) {
	//     gsap.to(".shopify-section-group-header-group", {
	//         onComplete: () => {
	//             document.querySelector(".shopify-section-group-header-group").classList.add("scrolled");
	//         }
	//     });
	// } else {
	//     gsap.to(".shopify-section-group-header-group", {
	//         onComplete: () => {
	//             document.querySelector(".shopify-section-group-header-group").classList.remove("scrolled");
	//         }
	//     });
	// }
});

///////////////////////////////
// Mouse Tracking Animations //
///////////////////////////////

// // Set up our coordinate mapping with GSAP utils
// let mapWidth;
// let mapHeight;

// function setMaps() {
//     mapWidth = gsap.utils.mapRange(0, innerWidth, -50, 50);
//     mapHeight = gsap.utils.mapRange(0, innerHeight, -50, 50);
// }

// window.addEventListener('resize', setMaps);
// setMaps();

// let xPosition;
// let yPosition;

// // updating the mouse coordinates
// function updateMouseCoords(event) {
//     xPosition = mapWidth(event.clientX);
//     yPosition = mapWidth(event.clientY);
// }
// window.addEventListener('mousemove', updateMouseCoords);

// // Animation for mouse tracking
// function movePointer() {
//     gsap.to(pointer, {
//         xPercent: xPosition,
//         yPercent: yPosition,
//         ease: 'none'
//         // ease: 'power4.out',
//         // ease: 'power4.in'
//     });
// }

// // gsap's RAF, falls back to set timeout
// gsap.ticker.add(movePointer);

// Select all elements with the class .mountain-items
const mountainItems = document.querySelectorAll('.mountain-items path');

// Create the animation
mountainItems.forEach((item) => {
	var direction = item.getAttribute('data-direction');
	if (direction == 'right') {
		hori = -60;
		vert = 0;
	} else if (direction == 'left') {
		hori = 60;
		vert = 0;
	} else {
		hori = 0;
		vert = -30;
	}

	gsap.from(item, {
		opacity: 0,
		x: hori,
		y: vert,
		duration: 0.5,
		ease: 'back.out(1.7)',
		scrollTrigger: {
			trigger: item,
			start: 'top 85%',
			toggleActions: 'play none none reverse',
		},
	});
});

// Add hover effect to .mountain-link elements
const mountainLinks = document.querySelectorAll('.mountain-link');

mountainLinks.forEach((link) => {
	link.addEventListener('mouseenter', () => {
		mountainItems.forEach((item, index) => {
			var direction = item.getAttribute('data-direction');
			if (direction == 'right') {
				hori = -5;
				vert = 0;
			} else if (direction == 'left') {
				hori = 5;
				vert = 0;
			} else {
				hori = 0;
				vert = 8;
			}

			gsap.to(item, {
				x: hori,
				y: vert,
				duration: 0.25,
				ease: 'power1.inOut',
				delay: index * 0.02, // Stagger the animations slightly
			});
		});
	});

	link.addEventListener('mouseleave', () => {
		mountainItems.forEach((item, index) => {
			gsap.to(item, {
				x: 0,
				y: 0,
				duration: 0.25,
				ease: 'power1.inOut',
				delay: index * 0.02, // Stagger the animations slightly
			});
		});
	});
});

// seal table .onclick

jQuery(function ($) {
	$('.nav-parent').click(function (e) {
		// If the click originated from .next-product or .prev-product, do nothing
		if (
			$(e.target).closest('.next-product').length ||
			$(e.target).closest('.prev-product').length
		) {
			return;
		}

		e.stopPropagation();

		const $this = $(this);
		const $menu = $this.find('.custom-mega-menu');

		// Close all other nav-parents and their menus
		$('.nav-parent')
			.not($this)
			.removeClass('active')
			.find('.custom-mega-menu.active')
			.removeClass('active')
			.fadeOut(200);

		// Toggle current nav-parent and menu
		$this.toggleClass('active');
		if ($menu.hasClass('active')) {
			$menu.removeClass('active').fadeOut();
		} else {
			$menu.addClass('active').fadeIn();
		}
	});

	// Optional: Close menu if clicking outside
	$(document).on('click', function (e) {
		const $target = $(e.target);
		// If click is inside any .custom-mega-menu or .nav-parent, do nothing
		if (
			$target.closest('.custom-mega-menu').length ||
			$target.closest('.nav-parent').length ||
			$target.closest('.next-product').length ||
			$target.closest('.prev-product').length
		) {
			return;
		}
		$('.nav-parent').removeClass('active');
		$('.custom-mega-menu.active').removeClass('active').fadeOut();
	});

	setTimeout(function () {
		console.log('3 seconds have passed');

		$(document).ready(function () {
			$('.jdgm-rev-widg__summary-average').each(function () {
				const text = $(this).text();
				const match = text.match(/[\d.]+/);
				if (match) {
					const truncated = Math.floor(parseFloat(match[0]) * 10) / 10;
					$(this).text(truncated.toFixed(1));
				}
			});
		});

		// const $radios = $('#product-grid .sls-option-container');

		// $radios.click(function () {

		// 	$this = $(this);

		// 	const $input = $(this).find('input[type="radio"]');
		// 	if ($input.length === 1) {

		// 		console.log($input);

		// 		const groupName = $input.attr('name');
		// 		const $group = $(`input.sls-option[name="${groupName}"]`);

		// 		if ($group.length === 2) {
		// 			// Set the active class based on which is checked

		// 			if ($this.hasClass('sls-active')) {
		// 				// If already active, remove the class
		// 				$this.removeClass('sls-active');
		// 				// $this.find('input[type="radio"]').trigger('checked', false);

		// 				console.log($this);
		// 				console.log('RADEIO: ' + $this.find('input[type="radio"]'));

		// 				$this.siblings('.sls-option-container').addClass('sls-active');
		// 				$this.siblings('.sls-option-container').find('input[type="radio"]').prop('checked', true);

		// 				// $this.siblings('.sls-option-container').find('input[type="radio"]').prop('checked', true);
		// 			}

		// 			// $group.each(function () {
		// 			// 	const $container = $(this).closest('.sls-option-container');
		// 			// 	if ($(this).prop('checked')) {
		// 			// 		$container.addClass('sls-active');
		// 			// 	} else {
		// 			// 		$container.removeClass('sls-active');
		// 			// 	}
		// 			// });

		// 		}
		// 	}

		// });

		// $radios.on('click', function () {
		// 	const $input = $(this).find('input');
		// 	console.log('Radio clicked:', $input.attr('name'), $input.val());

		// 	if ($input.prop('checked')) {

		// 		$(this).removeClass('sls-active');

		// 		const groupName = $input.attr('name');
		// 		const $group = $(`input.sls-option[name="${groupName}"]`);
		// 		$group.each(function () {
		// 			if (this !== $input[0]) $(this).prop('checked', true);
		// 		});
		// 	} else {

		// 	}
		// });

		const containers = document.querySelectorAll('.sls-option-container');

		containers.forEach((container) => {
			container.addEventListener('pointerdown', function (event) {
				const radio = this.querySelector('input.sls-option');
				if (radio && radio.checked) {
					event.preventDefault(); // prevent native toggle

					// Manually toggle to the other radio in the group
					const group = document.querySelectorAll(
						`input.sls-option[name="${radio.name}"]`
					);
					group.forEach((r) => {
						if (r !== radio) r.checked = true;
					});
				}
			});
		});
	}, 4000);

	gsap.to('#MainContent', {
		opacity: 1,
		duration: 0.4,
		ease: 'power2.out',
	});


	$('.newsletter-toggle-button').click(function () {
		$('.newsletter-modal').addClass('open');
	});

	$('.newsletter-modal-content-close').click(function () {
		$('.newsletter-modal').removeClass('open');
	});

	//////////////////////////////
	// Custom anchor scrolling //
	////////////////////////////

	function getSamePageAnchor(link) {
		if (
			link.protocol !== window.location.protocol ||
			link.host !== window.location.host ||
			link.pathname !== window.location.pathname ||
			link.search !== window.location.search
		) {
			return false;
		}

		return link.hash;
	}

	// Scroll to a given hash, preventing the event given if there is one
	function scrollToHash(hash, e) {
		const elem = hash ? document.querySelector(hash) : false;
		if (elem) {
			if (e) e.preventDefault();
			gsap.to(window, { scrollTo: elem });
		}
	}

	// If a link's href is within the current page, scroll to it instead
	document.querySelectorAll('a[href]').forEach((a) => {
		a.addEventListener('click', (e) => {
			scrollToHash(getSamePageAnchor(a), e);
		});
	});

	// Scroll to the element in the URL's hash on load
	setTimeout(() => scrollToHash(window.location.hash), 300);

	//.fade-up class reveal effect.
	fadeups = document.querySelectorAll('.fade-up');
	fadeups.forEach((fadeup) => {
		gsap.fromTo(
			fadeup,
			{
				y: 50,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				duration: 0.7,
				scrollTrigger: {
					trigger: fadeup,
					markers: false,
					start: 'top 95%',
					toggleActions: 'restart none none reverse',
				},
			}
		);
	});

	//.pop-in class reveal effect (scales in with a slight bounce)
	const popins = document.querySelectorAll('.pop-in');
	popins.forEach((popin) => {
		gsap.fromTo(
			popin,
			{
				scale: 0.2,
				opacity: 0,
			},
			{
				scale: 1,
				opacity: 1,
				duration: 0.4,
				ease: 'back.out(1.7)',
				scrollTrigger: {
					trigger: popin,
					markers: false,
					start: 'top 80%',
					toggleActions: 'restart none none reverse',
				},
			}
		);
	});

	// //paragraph reveal effect.
	// ps = document.querySelectorAll('p');
	// ps.forEach(p => {

	//     gsap.from(p, {
	//         y: 30,
	//         opacity: 0,
	//         duration: 0.4,
	//         scrollTrigger: {
	//             trigger: p,
	//             markers: false,
	//         },
	//         // onComplete: Can add a callback function here if needed.
	//     });

	// });

	//Header sub-menu content swap
	$('.mega-menu__link--level-2:not(#HeaderMenu-shop-shop-all)').on(
		'mouseenter',
		function () {
			var href = $(this).attr('href');
			$('.sub-collection-group').removeClass('open');
			$('.sub-collection-group[data-url="' + href + '"]').addClass('open');
		}
	);

	if (document.querySelectorAll('.slider-featured-products').length) {
		document.querySelectorAll('.slider-featured-products').forEach(function (s) {
			const id = s.id;
			console.log(id);

			const swiper = new Swiper(s, {
				autoHeight: false,
				loop: true,
				speed: 750,
				spaceBetween: 22,
				slidesPerView: 1.1,
				loopAdditionalSlides: 2,

				navigation: {
					nextEl: `.next-${id}`,
					prevEl: `.prev-${id}`,
				},

				breakpoints: {
					0: {
						spaceBetween: 15,
					},
					600: {
						slidesPerView: 1.2,
					},
					800: {
						spaceBetween: 22,
						slidesPerView: 1.5,
					},
					1300: {
						slidesPerView: 2,
					},
				},

				on: {
					slideChangeTransitionEnd: function () {
						// Clear all show-video classes
						s.querySelectorAll('.swiper-slide').forEach((slide) => {
							slide.classList.remove('show-video');
						});
						// Add to current active
						const active = s.querySelector('.swiper-slide-active');
						if (active) active.classList.add('show-video');
					},
				},
			});

			const slides = s.querySelectorAll('.product-slide');

			slides.forEach(function (slide) {
				slide.addEventListener('mouseenter', function () {
					// Only remove from active if hovering a non-active slide
					if (!slide.classList.contains('swiper-slide-active')) {
						const active = s.querySelector('.swiper-slide-active');
						if (active) active.classList.remove('show-video');
					}
				});

				slide.addEventListener('mouseleave', function () {
					// Always reset to only active slide
					s.querySelectorAll('.swiper-slide').forEach((slide) => {
						slide.classList.remove('show-video');
					});
					const active = s.querySelector('.swiper-slide-active');
					if (active) active.classList.add('show-video');
				});
			});
		});
	}

	document.querySelectorAll('.slider-apply').forEach(function (sliderApply) {
		new Swiper(sliderApply, {
			loop: false,
			speed: 750,
			slidesPerView: 1,
			spaceBetween: 20,

			// autoplay: {
			// 	delay: 6000,
			// 	disableOnInteraction: true,
			// },

			navigation: {
				nextEl: '.next-apply',
				prevEl: '.prev-apply',
			},

			//Responsive breakpoints if needed.
			breakpoints: {
				800: {
					slidesPerView: 2,
				},
				900: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		});
	});

	document.querySelectorAll('.slider-main').forEach(function (slider) {
		var id = slider.id;

		new Swiper(slider, {
			loop: true,
			speed: 750,
			effect: 'fade',

			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},

			navigation: {
				nextEl: '.next-slide',
				prevEl: '.prev-slide',
			},
		});
	});

	document.querySelectorAll('.slider-card').forEach(function (slider) {
		var id = slider.id;

		new Swiper(slider, {
			loop: true,
			speed: 750,
			effect: 'fade',

			autoplay: {
				delay: 6000,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.card-pagination',
				clickable: true,
			},
		});
	});

	document.querySelectorAll('.slider-image').forEach(function (sliderImage) {
		new Swiper(sliderImage, {
			loop: true,
			speed: 750,
			slidesPerView: 'auto',
			centeredSlides: true,
			initialSlide: 2,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},

			navigation: {
				nextEl: '.next-image',
				prevEl: '.prev-image',
			},

			// //Responsive breakpoints if needed.
			// breakpoints: {
			//     0: {
			//         spaceBetween: 15,
			//     },
			//     800: {
			//         spaceBetween: 22,
			//     },
			// },
		});
	});

	//Card Scroll
	if ($('.card-scroll-slider').length) {
		if (window.innerWidth < 801) {
			new Swiper('.card-scroll-slider', {
				loop: true,
				speed: 500,
				effect: 'fade',
				autoHeight: false,
				fadeEffect: {
					crossFade: true,
				},

				autoplay: {
					delay: 10000,
					disableOnInteraction: false,
				},

				pagination: {
					el: '.card-pagination',
					clickable: true,
				},
			});
		} else {
			new Swiper('.card-scroll-slider', {
				loop: true,
				speed: 500,
				effect: 'fade',
				autoHeight: false,
				fadeEffect: {
					crossFade: true,
				},

				autoplay: {
					delay: 10000,
					disableOnInteraction: false,
				},

				pagination: {
					el: '.card-pagination',
					clickable: true,
				},
			});
		}
	}

	//Team Member bios.
	$('.team-members .member').click(function () {
		var target = $(this).data('target');

		if (smoother && typeof smoother.paused === 'function') {
			smoother.paused(true);
		}

		$('.team-modals').fadeIn();
		$('.team-modal').removeClass('open');
		$('.team-modals')
			.find('#' + target)
			.addClass('open');
	});

	$('.team-modal .team-close, .team-modal-overlay').click(function () {
		$('.team-modals').fadeOut();
		$(this).closest('.team-modal').removeClass('open');

		if (smoother && typeof smoother.paused === 'function') {
			smoother.paused(false);
		}
	});

	//FAQ Category Filter
	$('.faq-cat').click(function () {
		var target = $(this).data('cat');

		$('.faq-cat').removeClass('active');
		$(this).addClass('active');

		$('.faq').hide();
		$('.faq.' + target).show();
	});

	//FAQ Accordion
	$('.faq .question').click(function () {
		$(this).parent().toggleClass('open');
		$(this).siblings('.answer').slideToggle();
	});

	document.querySelectorAll('.footer-lottie-player').forEach((lottiePlayer) => {
		ScrollTrigger.create({
			trigger: lottiePlayer,
			start: 'top 80%',
			onEnter: () => {
				if (typeof lottiePlayer.play === 'function') {
					lottiePlayer.play();
				} else {
					lottiePlayer.addEventListener(
						'ready',
						() => {
							lottiePlayer.play();
						}
						// { once: true }
					);
				}
			},
		});

		// Hover playback
		lottiePlayer.addEventListener('mouseenter', () => {
			if (typeof lottiePlayer.play === 'function') {
				lottiePlayer.seek(0);
				lottiePlayer.play();
			}
		});
	});

	document.querySelectorAll('.map-animation lottie-player').forEach((mapAnimation) => {
		ScrollTrigger.create({
			trigger: mapAnimation,
			start: 'top 80%',
			// markers: true,
			onEnter: () => {
				if (typeof mapAnimation.play === 'function') {
					mapAnimation.play();
				}
			},
		});
	});

	document.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
		button.innerHTML =
			'<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg></span> Back';
	});

	// Video Card Hover
	const videoCards = document.querySelectorAll('.video-card-hover');
	if (videoCards.length) {
		videoCards.forEach((videoCard) => {
			const video = videoCard.querySelector('video');
			if (video) {
				videoCard.addEventListener('mouseenter', () => {
					video.currentTime = 0;
					video.play();
				});
			}
		});
	}

	$('.forgot-password').click(function(){
		$('#recover').show();
		$('#recover + div').show();

		$('#login').hide();
		$('#login + div').hide();
	});

	$('a[href="#login"]').click(function(){
		$('#recover').hide();
		$('#recover + div').hide();

		$('#login').show();
		$('#login + div').show();
	});
});

document.addEventListener('DOMContentLoaded', function () {
	setupWpdHoverPauseForSmoother();

	document.querySelectorAll('.nav-item').forEach(function (navItem) {
		let href = navItem.getAttribute('href');
		if (!href) {
			const link = navItem.querySelector('a');
			if (link) href = link.getAttribute('href');
		}
		if (href) {
			const normalize = (url) => (url ? url.replace(/\/+$/, '') : '');
			const getPath = (url) => {
				try {
					return new URL(url, window.location.origin).pathname;
				} catch {
					return null;
				}
			};

			const currentPath = normalize(window.location.pathname);
			const navPath = normalize(getPath(href));

			if (
				navPath &&
				(currentPath === navPath || currentPath === decodeURIComponent(navPath))
			) {
				navItem.classList.add('current-page');
			}
		}
	});

	if (document.querySelector('.header-product-slider')) {
		const headerProductSliders = document.querySelectorAll('.header-product-slider');

		headerProductSliders.forEach((slider) => {
			const id = slider.id;

			const s = new Swiper('#' + id, {
				slidesPerView: 'auto',
				spaceBetween: 24,
				loop: true,
				// autoplay: {
				// 	delay: 5000,
				// 	disableOnInteraction: false,
				// },
				navigation: {
					nextEl: '#' + id + ' .next-product',
					prevEl: '#' + id + ' .prev-product',
				},
				on: {
					slideChangeTransitionEnd: function () {
						s.el.querySelectorAll('.swiper-slide').forEach((slide) => {
							slide.classList.remove('show-video');
						});
						const active = s.el.querySelector('.swiper-slide-active');
						if (active) active.classList.add('show-video');
					},
				},
			});

			const slides = slider.querySelectorAll('.header-slide');

			slides.forEach((slide) => {
				slide.addEventListener('mouseenter', () => {
					if (!slide.classList.contains('swiper-slide-active')) {
						const active = slider.querySelector('.swiper-slide-active');
						if (active) active.classList.remove('show-video');
					}
				});

				slide.addEventListener('mouseleave', () => {
					slider.querySelectorAll('.swiper-slide').forEach((el) => {
						el.classList.remove('show-video');
					});
					const active = slider.querySelector('.swiper-slide-active');
					if (active) active.classList.add('show-video');
				});
			});
		});
	}

	if (document.querySelector('.company-icon')) {
		const boxes = gsap.utils.toArray('.company-icon'),
			loop = horizontalLoop(boxes, {
				paused: false,
				speed: 0.5,
				repeat: true,
			});
	}

	if (document.querySelector('.feature')) {
		const featureIcons = gsap.utils.toArray('.feature'),
			loop = horizontalLoop(featureIcons, {
				paused: false,
				speed: 0.5,
				repeat: true,
			});
	}

	const sportRows = document.querySelectorAll('.sport-row');
	sportRows.forEach((row) => {
		var isReversed = row.classList.contains('right');
		console.log(isReversed);

		const boxes = gsap.utils.toArray(row.querySelectorAll('.sport-item'));
		horizontalLoop(boxes, {
			paused: false,
			speed: 0.5,
			repeat: true,
			reversed: isReversed,
		});
	});

	// Sticky Scroll Image
	if (document.querySelector('.sticky-section')) {
		gsap.registerPlugin(ScrollTrigger);

		// Set initial state - hide all images except the first one
		gsap.set('.sticky-img-item', { opacity: 0 });
		gsap.set('.sticky-img-item:first-child', { opacity: 1 });

		// Get all sticky text elements
		var stickyTexts = gsap.utils.toArray('.sticky-text');
		var stickyImages = gsap.utils.toArray('.sticky-img-item');

		// Get the sticky container and image element
		var stickyContainer = document.querySelector('.sticky-main');
		var stickyImg = document.querySelector('.sticky-img');

		// Calculate the proper end point for sticky behavior accounting for padding
		var containerStyles = window.getComputedStyle(stickyContainer);
		var containerHeight = stickyContainer.offsetHeight;
		var containerPaddingTop = parseFloat(containerStyles.paddingTop);
		var containerPaddingBottom = parseFloat(containerStyles.paddingBottom);
		var containerInnerHeight =
			containerHeight - containerPaddingTop - containerPaddingBottom;

		var imgHeight = stickyImg.offsetHeight;
		var stickyDistance = containerInnerHeight - imgHeight;

		// Pin the sticky image container with proper end calculation
		ScrollTrigger.create({
			trigger: '.sticky-main',
			start: 'top top',
			end: () => `+=${stickyDistance}`, // This creates the sticky effect
			pin: '.sticky-img',
			pinSpacing: false, // Changed to false for better sticky behavior
			invalidateOnRefresh: true,
			onRefresh: function () {
				// Recalculate on refresh accounting for padding
				containerStyles = window.getComputedStyle(stickyContainer);
				containerHeight = stickyContainer.offsetHeight;
				containerPaddingTop = parseFloat(containerStyles.paddingTop);
				containerPaddingBottom = parseFloat(containerStyles.paddingBottom);
				containerInnerHeight =
					containerHeight - containerPaddingTop - containerPaddingBottom;
				imgHeight = stickyImg.offsetHeight;
				stickyDistance = containerInnerHeight - imgHeight;
			},
		});

		// Create fade animations for each text/image pair
		stickyTexts.forEach((text, i) => {
			var tl = gsap.timeline({
				scrollTrigger: {
					trigger: text,
					start: 'top 80%',
					end: 'bottom 20%',
					scrub: 1,
					invalidateOnRefresh: true,
				},
			});

			if (stickyImages[i]) {
				tl.fromTo(
					stickyImages[i],
					{ opacity: 0 },
					{
						opacity: 1,
						duration: 0.5,
						ease: 'power2.out',
					}
				);
			}
		});

		// Optional: Add a refresh function for dynamic content
		ScrollTrigger.addEventListener('refresh', () => {
			containerStyles = window.getComputedStyle(stickyContainer);
			containerHeight = stickyContainer.offsetHeight;
			containerPaddingTop = parseFloat(containerStyles.paddingTop);
			containerPaddingBottom = parseFloat(containerStyles.paddingBottom);
			containerInnerHeight =
				containerHeight - containerPaddingTop - containerPaddingBottom;
			imgHeight = stickyImg.offsetHeight;
			stickyDistance = containerInnerHeight - imgHeight;
		});
	}

	if (document.querySelector('.partner-slider')) {
		const swiper = new Swiper('.partner-slider', {
			slidesPerView: 1,
			loop: true,

			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// },

			navigation: {
				nextEl: '.next-partner',
				prevEl: '.prev-partner',
			},

			breakpoints: {
				600: {
					slidesPerView: 2,
				},

				768: {
					slidesPerView: 4,
				},
			},
		});
	}

	if (document.querySelector('.ingredients-slider')) {
		const swiper = new Swiper('.ingredients-slider', {
			slidesPerView: 1,
			spaceBetween: 10,
			loop: true,

			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},

			navigation: {
				nextEl: '.next-ingredient',
				prevEl: '.prev-ingredient',
			},

			breakpoints: {
				600: {
					slidesPerView: 2,
				},

				800: {
					slidesPerView: 3,
				},

				1024: {
					slidesPerView: 4,
				},

				1100: {
					slidesPerView: 5,
				},
			},
		});
	}

	if (document.querySelector('.press-slider')) {
		const swiper = new Swiper('.press-slider', {
			slidesPerView: 1,
			spaceBetween: 10,
			loop: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},

			navigation: {
				nextEl: '.press-next',
				prevEl: '.press-prev',
			},

			pagination: {
				el: '.press-pagination',
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + '</span>';
				},
				clickable: true,
			},
		});
	}


	$('.view-athletes a').click(function () {
		$('.view-athletes').fadeOut();
		$('.member').fadeIn();
	});
});

/*
This helper function makes a group of elements animate along the x - axis in a seamless, responsive loop.

Features:
- Uses xPercent so that even if the widths change(like if the window gets resized), it should still work in most cases.
- When each item animates to the left or right enough, it will loop back to the other side
- Optionally pass in a config object with values like "speed"(default: 1, which travels at roughly 100 pixels per second), paused(boolean), repeat, reversed, and paddingRight.
- The returned timeline will have the following methods added to it:
- next() - animates to the next element using a timeline.tweenTo() which it returns.You can pass in a vars object to control duration, easing, etc.
- previous() - animates to the previous element using a timeline.tweenTo() which it returns.You can pass in a vars object to control duration, easing, etc.
- toIndex() - pass in a zero - based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc.Always goes in the shortest direction
- current() - returns the current index(if an animation is in -progress, it reflects the final index)
- times - an Array of the times on the timeline where each element hits the "starting" spot.There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
*/

function horizontalLoop(items, config) {
	items = gsap.utils.toArray(items);
	config = config || {};
	let tl = gsap.timeline({
		repeat: config.repeat,
		paused: config.paused,
		defaults: { ease: 'none' },
		onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
	}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		xPercents = [],
		curIndex = 0,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
		totalWidth,
		curX,
		distanceToStart,
		distanceToLoop,
		item,
		i;
	gsap.set(items, {
		// convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
		xPercent: (i, el) => {
			let w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')));
			xPercents[i] = snap(
				(parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 +
				gsap.getProperty(el, 'xPercent')
			);
			return xPercents[i];
		},
	});
	gsap.set(items, { x: 0 });
	totalWidth =
		items[length - 1].offsetLeft +
		(xPercents[length - 1] / 100) * widths[length - 1] -
		startX +
		items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
		(parseFloat(config.paddingRight) || 0);
	for (i = 0; i < length; i++) {
		item = items[i];
		curX = (xPercents[i] / 100) * widths[i];
		distanceToStart = item.offsetLeft + curX - startX;
		distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');
		tl.to(
			item,
			{
				xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
				duration: distanceToLoop / pixelsPerSecond,
			},
			0
		)
			.fromTo(
				item,
				{
					xPercent: snap(
						((curX - distanceToLoop + totalWidth) / widths[i]) * 100
					),
				},
				{
					xPercent: xPercents[i],
					duration:
						(curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
					immediateRender: false,
				},
				distanceToLoop / pixelsPerSecond
			)
			.add('label' + i, distanceToStart / pixelsPerSecond);
		times[i] = distanceToStart / pixelsPerSecond;
	}
	function toIndex(index, vars) {
		vars = vars || {};
		Math.abs(index - curIndex) > length / 2 &&
			(index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex) {
			// if we're wrapping the timeline's playhead, make the proper adjustments
			vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		curIndex = newIndex;
		vars.overwrite = true;
		return tl.tweenTo(time, vars);
	}
	tl.next = (vars) => toIndex(curIndex + 1, vars);
	tl.previous = (vars) => toIndex(curIndex - 1, vars);
	tl.current = () => curIndex;
	tl.toIndex = (index, vars) => toIndex(index, vars);
	tl.times = times;
	tl.progress(1, true).progress(0, true); // pre-render for performance
	if (config.reversed) {
		tl.vars.onReverseComplete();
		tl.reverse();
	}
	return tl;
}
